// extracted by mini-css-extract-plugin
module.exports = {"navbarLinkButton":"NavbarLinkButton-module--navbarLinkButton--22w_e"};